import styled from 'styled-components';

import Colors from '@rockalingua/ui/constants/Colors';

export const MessageHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${Colors.ACCENT_VARIANTS[70]};
  object-fit: contain;
`;
